const CaasLocalStorageKeys = {
  NAVIGATION_COMPONENTS: 'navigationComponents',
  ORGANIZATIONS_NAMES: 'organizationsNames',
};

export default CaasLocalStorageKeys;
